import {
    forwardRef
} from "react";
import {
    type ScrollViewProps,
    ScrollView,
    Platform
} from "react-native";
import type IPopoverSurfaceListProps from "./type";
import type {
    PopoverSurfaceListWebPropsType,
    IPopoverSurfaceListRef
} from "./type";
import stylesheet, {
    POPOVER_SURFACE_LIST_MAX_ROWS,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import type {
    RefForwardingComponent
} from "../../../../types";

const PopoverSurfaceList: RefForwardingComponent<IPopoverSurfaceListRef, IPopoverSurfaceListProps> = ({
    maxRows = POPOVER_SURFACE_LIST_MAX_ROWS,
    contentContainerStyle,
    isMultiple = false,
    role = "listbox",
    isBusy = false,
    customTheme,
    children,
    style,
    ...props
}, ref) => {
    const {
        controlHeights,
        touchTargets
    } = NCoreUIKitTheme.useContext(customTheme);

    const pointerType = usePointerType();

    const {
        list: listDynamicStyle
    } = useStyles({
        controlHeights,
        touchTargets,
        pointerType,
        maxRows
    });

    const webProps: PopoverSurfaceListWebPropsType = Platform.OS === "web" ? {
        "aria-multiselectable": role === "listbox" && isMultiple ? true : undefined
    } : {};

    const roleProps = {
        role
    } as Pick<ScrollViewProps, "role">;

    return <ScrollView
        {...props}
        {...webProps}
        {...roleProps}
        showsHorizontalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={[
            stylesheet.content,
            contentContainerStyle
        ]}
        style={[
            style,
            stylesheet.list,
            listDynamicStyle
        ]}
        aria-busy={isBusy}
        ref={ref}
    >
        {children}
    </ScrollView>;
};
export default forwardRef(PopoverSurfaceList);
